import { render, staticRenderFns } from "./string-array.vue?vue&type=template&id=38eba7fc&scoped=true&"
import script from "./string-array.vue?vue&type=script&lang=ts&"
export * from "./string-array.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eba7fc",
  null
  
)

export default component.exports